import { ArrowRight } from "lucide-react";
import { Button, Section, withHighlight } from "@/components/ui";

/** Closing band for writer-supplied industry pages: one question, one line, one button. */
export function IndustryCta({ cta }) {
  return (
    <Section tone="brand" labelledBy="industry-cta-title" testId="industry-cta" spacing="roomy" innerClassName="text-center">
      <div className="relative z-10">
        <h2 id="industry-cta-title" className="mx-auto max-w-[18ch] font-heading text-4xl font-bold leading-[1.05] [text-wrap:balance] sm:text-6xl">
          {withHighlight(cta.title, "your fit")}
        </h2>
        <p className="mx-auto mt-5 max-w-[44ch] text-lg text-ink/70 sm:text-xl">{cta.text}</p>
        <div className="mt-8">
          <Button to="/contact" size="lg" data-testid="industry-cta-button">
            {cta.label}
            <ArrowRight className="h-5 w-5" aria-hidden="true" />
          </Button>
        </div>
      </div>
    </Section>
  );
}
